<form [formGroup]="customerIncludeForm" [style]="{'max-width': '60rem'}" class="w-full">
  <!-- Haupt-Container, der die linke und rechte Sektion trennt -->
  <div class="flex flex-row pb-1">

    <!-- LINKE SEKTION: Labels und Inputs -->
    <div class="flex flex-row flex-grow-1 mr-4">

      <!-- SPALTE 1: Labels (feste Breite) -->
      <div class="flex flex-column gap-1">
        <!-- Bank Label -->
        <div [style]="{height: '27px'}" class="flex align-items-center">
          @if (isRefiContext()) {
            <label class="font-normal text-color" [style]="{width: '7rem'}"
                   for="bank">{{ "administration.customer.bank" | translate }}</label>
          } @else if (isCorporateCustomer() || isCorporateMode()) {
            <label class="align-self-center font-normal text-color" [style]="{width: '7rem'}"
                   for="bank">{{ "administration.customer.corporate" | translate }}</label>
          } @else {
            <label class="font-normal text-color" [style]="{width: '7rem'}"
                   for="bank">{{ "administration.customer.bank" | translate }}</label>
          }
        </div>
        <!-- Händler Label -->
        <div [style]="{height: '27px'}" class="flex align-items-center">
          @if (isRefiContext()) {
            <label class="w-9rem font-normal text-color"
                   for="retailer">{{ "administration.customer.traderRefi" | translate }}</label>
          } @else if (isLicoOrigin()) {
            <label class="mt-4 w-6rem font-normal text-color"
                   for="retailer">{{ "administration.customer.trader" | translate }}</label>
          } @else {
            <label class="w-6rem font-normal text-color"
                   for="retailer">{{ "administration.customer.trader" | translate }}</label>
          }
        </div>
      </div>

      <!-- SPALTE 2: Inputs (flexible Breite) -->
      <div class="flex flex-column flex-grow-1 gap-1 ml-2">
        <!-- Bank Input -->
        <div [style]="{height: '27px'}" class="flex align-items-center">
          @if (isDzBankUser()) {
            <p-auto-complete #autocompleteBank autofocus full-width-autocomplete
                             (onBlur)="onBankChange()"
                             (completeMethod)="search($event)" (onSelect)="onSelect($event)" (onClear)="onClear()"
                             [inputStyle]="{ height: '27px', width: '100%'}"
                             [inputStyleClass]="'text-overflow-ellipsis white-space-nowrap'"
                             [suggestions]="suggestedCustomers()" forceSelection="true"
                             id="bank" inputId="bankInput" formControlName="bank" optionLabel="name"
                             [showClear]="true" scrollHeight="300px">
              <ng-template let-customer pTemplate="item">
                <div class="flex align-items-center gap-2">
                  @if (hasMixedCustomerTypes()) {
                    @if (customer.type === CustomerType.Bankkunde) {
                      <span class="inline-block lion-bank text-color-secondary" style="width: 1.2em; height: 1.2em;"></span>
                    } @else if (customer.type === CustomerType.Firmenkunde) {
                      <span class="inline-block lion-corporate text-color-secondary" style="width: 1.2em; height: 1.2em;"></span>
                    }
                  }
                  <span>{{ customer.name }}@if (customer.sapGpNumber) { (SAP-GP: {{ customer.sapGpNumber }})}</span>
                </div>
              </ng-template>
            </p-auto-complete>
          } @else if (isCorporateMode() && suggestedCustomers().length > 1) {
            <p-select [options]="suggestedCustomers()"
                      [style]="{ width: '25rem', 'margin-left': '-10px'}"
                      id="customerObject" formControlName="customerObject" optionLabel="name"
                      dataKey="id"
                      scrollHeight="300px" >
              <ng-template #selectedItem let-selectedItem>
                <span>{{ selectedItem.name }}</span>
              </ng-template>
              <ng-template #item let-item>
                <span>{{ item.name }}</span>
              </ng-template>
            </p-select>
          } @else {
            <div class="align-self-center">{{ selectedKunde()?.name }}</div>
          }
        </div>
        <!-- Händler Input -->
        <div [style]="{height: '27px'}" class="flex align-items-center">
          @if (isDzBankUser()) {
            @if (isCorporateMode() || isCorporateCustomer()) {
              <p-auto-complete #autocompleteRetailer full-width-autocomplete (completeMethod)="searchRetailer($event)"
                               (onFocus)="onRetailerFocus()" (onClear)="onRetailerClear()" (onBlur)="onRetailerBlur()"
                               [forceSelection]="false" [minQueryLength]="0"
                               [inputStyle]="{ 'min-width': '10rem', width: '100%', height: '27px'}"
                               [inputStyleClass]="'text-overflow-ellipsis white-space-nowrap'"
                               (onSelect)="onSelectRetailer($event)" [suggestions]="filteredRetailers() ?? []"
                               id="retailer"
                               formControlName="retailer" optionLabel="name" [dropdown]="false"
                               [showEmptyMessage]="false"
                               [showClear]="true" scrollHeight="300px"/>
              <p-button [style]="{width: '27px', height: '27px'}" severity="secondary" class="ml-1"
                        icon="pi pi-user-edit"
                        pTooltip="{{ 'shared.customer.retailer.dialog.header' | translate }}"
                        (onClick)="openHaendlerFirmenkundeDialog()"
                        [disabled]="!selectedKunde()"></p-button>
            } @else {
              <p-auto-complete #autocompleteRetailer full-width-autocomplete
                               (completeMethod)="searchRetailer($event)" (onFocus)="onRetailerFocus()"
                               (onClear)="onRetailerClear()" (onBlur)="onRetailerBlur()" [forceSelection]="false"
                               [minQueryLength]="0"
                               [inputStyle]="{ 'min-width': '10rem', width: '100%', height: '27px'}"
                               [inputStyleClass]="'text-overflow-ellipsis white-space-nowrap'"
                               (onSelect)="onSelectRetailer($event)" [suggestions]="filteredRetailers() ?? []"
                               id="retailer"
                               formControlName="retailer" optionLabel="name" [dropdown]="false"
                               [showEmptyMessage]="false"
                               [showClear]="true" scrollHeight="300px"/>
            }
          } @else {
            @if (isLicoOrigin()) {
              <div class="mt-4 align-self-center">{{ name() }}</div>
            } @else {
              <div class="align-self-center">{{ name() }}</div>
            }
          }
        </div>
      </div>
    </div>

    <!-- RECHTE SEKTION: DZ Bank Felder (unverändert) -->
    @if (isDzBankUser()) {
      <div class="flex flex-row">
        <div class="flex flex-column gap-1 pr-4">
          @if (!isCorporateMode()) {
            @if (!isCorporateCustomer()) {
              <div class="flex flex-row align-items-center">
                <label [style]="{width: '4.5rem'}" class="text-sm font-normal" for="accountNr">
                  {{ "administration.customer.accountNr" | translate }}
                </label>
                <input id="accountNr" [style]="{width: '9rem', height: '27px'}" class="text-right"
                       formControlName="kto" pInputText type="text"
                       (keydown.enter)="onKeyDown( 'kto', KundenField.Kontonummer)"
                       (keydown.tab)="onKeyDown( 'kto', KundenField.Kontonummer)"/>
              </div>
            }
          }
          @if (!isCorporateMode()) {
            @if (!isCorporateCustomer()) {
              <div class="flex flex-row align-items-center">
                <label [style]="{width: '4.5rem'}" class="text-sm font-normal" for="wp2Nr">
                  {{ "administration.customer.wp2Nr" | translate }}
                </label>
                <input id="wp2Nr" [style]="{width: '9rem', height: '27px'}" class="text-right"
                       formControlName="wp2" pInputText type="text"
                       (keydown.enter)="onKeyDown( 'wp2', KundenField.Wpnummer)"
                       (keydown.tab)="onKeyDown( 'wp2', KundenField.Wpnummer)"/>
              </div>
            }
          }
        </div>
        <div class="flex flex-column gap-1">
          <div class="flex flex-row align-items-center">
            <label [style]="{width: '4.5rem'}" class="text-sm font-normal" for="sapGp">
              {{ "administration.customer.sapGp" | translate }}
            </label>
            <input id="sapGp" [style]="{width: '9rem', height: '27px'}" class="flex text-right"
                   formControlName="sapgp" pInputText type="text"
                   (keydown.enter)="onKeyDown( 'sapgp', KundenField.Sapgpnummer)"
                   (keydown.tab)="onKeyDown( 'sapgp', KundenField.Sapgpnummer)"/>
          </div>
          <div class="flex flex-row align-items-center">
            <label [style]="{width: '4.5rem'}" class="text-sm font-normal" for="murex">
              {{ "administration.customer.murex" | translate }}
            </label>
            <input id="murex" [style]="{width: '9rem', height: '27px'}" class="text-right"
                   formControlName="murex" pInputText type="text"
                   (keydown.enter)="onKeyDown( 'murex', KundenField.Murexlabel)"
                   (keydown.tab)="onKeyDown( 'murex', KundenField.Murexlabel)"/>
          </div>
        </div>
      </div>
    }
  </div>
  <div [style]="{'margin-top': '0.15rem'}">
    @if (messageState()) {
      <p-message variant="outlined" [severity]="messageState()?.severity">
        {{ messageState()?.message }}
      </p-message>
    }
  </div>
</form>

<p-dialog [(visible)]="haendlerFirmenkundeDialogVisible"
          [draggable]="false" [modal]="true" [resizable]="false"
          [style]="{ width: '30rem' }"
          header="{{ 'shared.customer.retailer.dialog.header' | translate }}"
          (onShow)="focusInput()">

  <form [formGroup]="retailerFormGroup">
    <div class="flex flex-row">
      <div class="flex align-items-center justify-content-evenly mb-3 column-gap-1">
        <label class="w-10rem"
               for="form_name">{{ "shared.customer.retailer.dialog.inputRetailer" | translate }}</label>
        <input class="w-17rem" formControlName="name" id="form_name" pInputText/>
      </div>
    </div>

    <div class="flex flex-row">
      <div class="flex align-items-center justify-content-evenly mb-3 column-gap-1">
        <label class="w-10rem"
               for="form_telefon">{{ "shared.customer.retailer.dialog.inputPhone" | translate }}</label>
        <input class="w-17rem" formControlName="telefon" id="form_telefon" pInputText #focusInputElement/>
      </div>
    </div>

    <div class="flex flex-row">
      <div class="flex align-items-center justify-content-evenly mb-3 column-gap-1">
        <label class="w-10rem"
               for="form_handy">{{ "shared.customer.retailer.dialog.inputMobile" | translate }}</label>
        <input class="w-17rem" formControlName="handy" id="form_handy" pInputText/>
      </div>
    </div>

    <div class="flex flex-row">
      <div class="flex align-items-center justify-content-evenly mb-3 column-gap-1">
        <label class="w-10rem"
               for="beauftragungsweg">{{ "shared.customer.retailer.dialog.inputBeauftragungsweg" | translate }}</label>
        <p-select [options]="beauftragungswegOptions" appendTo="body" class="w-17rem"
                  formControlName="beauftragungsweg" id="beauftragungsweg" optionLabel="label" optionValue="value"
                  placeholder="Bitte wählen"></p-select>
      </div>
    </div>

  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-between w-full">
      <p-button (onClick)="haendlerFirmenkundeDialogVisible=false" icon="pi pi-times"
                label="{{ 'common.cancel' | translate }}"
                severity="secondary" variant="outlined"></p-button>
      <div class="flex flex-row gap-2">
        <p-button (onClick)="deleteRetailer()" [disabled]="retailerFormGroup.invalid" icon="pi pi-trash"
                  label="{{ 'common.delete' | translate }}" variant="outlined"></p-button>
        <p-button (onClick)="saveRetailer()" [disabled]="retailerFormGroup.invalid" icon="pi pi-check"
                  label="{{ 'common.save' | translate }}" variant="outlined"></p-button>
      </div>
    </div>

  </ng-template>
</p-dialog>
